import React from "react";
import { Typography } from "@mui/material";
import { ComponentExample } from "components/examples";

const FormVirtualization = () => (
  <React.Fragment>
    <Typography variant="h5" gutterBottom>
      Form Virtualization
    </Typography>
    <ComponentExample
      name="Virtualized array"
      description="Virtualization can be enabled on both Form Array and ArrayTable components. Ideally items should have a fixed height to allow the browser/overflow container scrollbar to accurately represent the overall height."
      import={import(
        "examples/Forms/FormVirtualization/VirtualizedArrayExample"
      )}
      rawImport={import(
        "examples/Forms/FormVirtualization/VirtualizedArrayExample?raw"
      )}
    />
  </React.Fragment>
);

export default FormVirtualization;
